import React, { useEffect, useRef } from 'react';
import { Row } from 'react-styled-flexboxgrid';
import { StoryblokComponent, storyblokEditable } from 'gatsby-source-storyblok';
import { object } from 'prop-types';
import styled, { css } from 'styled-components';
import { useAppState } from '../../../context/app-state.context';
import { useRootState } from '../../../context/root-state.context';
import { StoreContext } from '../../../context/store-context';
import { useIsomorphicLayoutEffect } from '../../../hooks';
import { inputLabels } from '../../../state/settings/settingsReducer';
import { bpWidthMobileFirst } from '../../../styles/variables';
import Cart from '../../Cart/Cart';
import CategoryPosts from '../blogs/CategoryPosts';
import FixedBottom from '../fixed-bottom/FixedBottom';
import FixedShopCta from '../fixed-bottom/FixedShopCta';
import FooterWrapper from '../Footer/FooterWrapper';
import HeaderWrapper from '../Header/HeaderWrapper';
import Search from '../search/Search';

const Main = styled.main`
  display: flex;
  flex-direction: column;
  margin: 0;
  padding: 0;
  width: 100%;
  height: 100%;
`;

const BodyWrapper = styled.div`
  flex: 1;

  ${({ withBgImg, bgImg }) => {
    if (withBgImg) {
      return css`
        background-image: url(${bgImg.filename});
        background-size: 200%;

        @media (${bpWidthMobileFirst.tablet}) {
          background-attachment: fixed;
          background-size: cover;
          background-repeat: no-repeat;
        }
      `;
    }

    return undefined;
  }};
`;

const Layout = ({ blok }) => {
  const cartColInnerEl = useRef(null);
  const { categoryPostsSbStories, fixedBottomSetting } = useRootState();
  const { dispatchSetting, searchIsOpen, toggleSearch } = useAppState();
  const { initializeCart } = React.useContext(StoreContext);

  useIsomorphicLayoutEffect(() => {
    dispatchSetting({
      name: inputLabels.showCartIcon,
      value: blok.showCartIcon || false,
    });
  }, [blok.showCartIcon]);

  useIsomorphicLayoutEffect(() => {
    dispatchSetting({
      name: inputLabels.showSearchIcon,
      value: blok.showSearchIcon || false,
    });
  }, [blok.showSearchIcon]);

  useIsomorphicLayoutEffect(() => {
    dispatchSetting({
      name: inputLabels.navLightMode,
      value: blok.navLightMode || false,
    });
    dispatchSetting({
      name: inputLabels.navFontColorLight,
      value: blok.navLightMode || false,
    });
  }, [blok.navLightMode]);

  useEffect(() => {
    initializeCart();
  }, []);

  return (
    <Main {...storyblokEditable(blok)} id="bodyContent">
      <HeaderWrapper />

      <BodyWrapper withBgImg={blok.withBgImg} bgImg={blok.bgImg}>
        {blok.body?.map((nestedBlok) => (
          <Row key={nestedBlok._uid}>
            <StoryblokComponent blok={nestedBlok} />
          </Row>
        ))}

        {/* Category posts */}
        {categoryPostsSbStories?.total > 0 && <CategoryPosts sbStories={categoryPostsSbStories} />}
      </BodyWrapper>

      {(fixedBottomSetting === 'show' || fixedBottomSetting === 'showHide') && (
        <FixedBottom fixedBottomSetting={fixedBottomSetting}>
          <div className="text-right">
            <FixedShopCta />
          </div>
        </FixedBottom>
      )}

      <FooterWrapper />

      <Search searchIsOpen={searchIsOpen} handleSearchToggle={toggleSearch} />

      <Cart ref={cartColInnerEl} />
    </Main>
  );
};

Layout.propTypes = {
  blok: object.isRequired,
};

export default Layout;
